import * as React from "react";
const SvgBolt = props => <svg xmlns="http://www.w3.org/2000/svg" width={200} height={307} fill="none" viewBox="0 0 200 307" {...props}><path d="m56 0 51.606 131H0l177 176-70.021-142H200z" /></svg>;
export default SvgBolt;